<script setup lang="ts">
import { appStore } from "../stores/app";
</script>

<template>
    <div class="loader-wrapper bulma-contextual" :class="{ 'is-active': appStore.loading }">
        <div class="loader is-primary is-loading"></div>
    </div>
</template>
